<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('CargoMsg.Cargo_ViewContract')"
    :width="isZh?'750px':'850px'"
    :close-on-click-modal="false"
    class="app-main-inner"
  >
    <el-form :inline="true" :label-width="isZh?'80px':'130px'" label-position="left">
      <el-row>
        <el-col :span="24">
          <el-form-item>
            <span slot="label" class="blue">{{ $t('CargoMsg.Cargo_Parter') }}</span>
            <cargo-advance-select
              no="cmpIdx"
              :disabled="true"
              :select-type="selectTypeNames.basic_data_Company"
              filterable
              style="width: 230px;"
              :method-params="{active:true}"
              :default-value="tempCreditVO.cmpIdx||''"
              @parentCallBack="p=>{tempCreditVO.cmpIdx=p.value || 0;tempCreditVO.branchId=$store.getters.currentOfficeId}"
            />
          </el-form-item>
          <el-form-item>
            <span slot="label" class="blue">{{ $t('CargoMsg.Cargo_ContractNumber') }}</span>
            <el-input v-model="tempCreditVO.contractNo" no="contractNo" style="width: 230px;" :disabled="true" />
          </el-form-item>
        </el-col>
      </el-row>
      <div style="border-bottom: 2px solid #E3E3E3; margin-bottom: 10px; margin-top: 10px;" />
      <span style="line-height: 25px; font-weight: bold;">{{ $t('CargoMsg.Cargo_CurrentCredit') }}</span>
      <el-row>
        <el-col :span="24">
          <el-form-item :label="$t('Partners.limit')">
            <el-input-number
              v-model="tempCreditVO.credit"
              no="credit"
              disabled
              :min="0"
              :precision="0"
              :controls="false"
              style="width:70px;"
            />
            <el-select v-model="tempCreditVO.currency" no="currency" style="margin-left:5px;width:88px;" disabled>
              <el-option
                v-for="(item,index) in currencySet"
                :key="index"
                :label="item.code"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('Partners.accountPeriod')">
            <el-input-number
              v-model="tempCreditVO.creditDateLimited"
              no="dateLimited"
              disabled
              :min="0"
              :precision="0"
              :controls="false"
              style="width:74px;"
            />
            <el-select v-model="tempCreditVO.termUnit" no="termUnit" style="margin-left:5px;width:70px;" disabled>
              <el-option :label="$t('Partners.day')" :value="0" />
              <el-option :label="$t('Partners.week')" :value="1" />
              <el-option :label="$t('Partners.month')" :value="2" />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <div style="border-bottom: 2px solid #E3E3E3; margin-bottom: 10px; margin-top: 10px;" />
      <span style="line-height: 25px; font-weight: bold;">{{ $t('CargoMsg.Cargo_ContractTerms') }}</span>
      <el-row style="margin-top: 10px;">
        <el-col :span="24">
          <el-form-item :label="$t('Partners.dateType')">
            <el-select v-model="tempCreditVO.contractDateType" no="dateType" style="width: 163px;" :disabled="true">
              <el-option
                v-for="(item,index) in dateTypeList"
                :key="index"
                :label="$getLangColumn(item)"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('Partners.settlementMethod')">
            <el-select v-model="cbType" no="cbType" :disabled="true">
              <el-option
                v-for="(item,index) in cbTypeList"
                :key="index"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-input-number
            v-if="cbType==='n'"
            no="tiDateSpecify"
            :disabled="true"
            :value="tiDateSpecify||undefined"
            :min="0"
            :max="31"
            :precision="0"
            :controls="false"
            style="width:70px;"
            @input="val=>{this.tiDateSpecify=val}"
          />
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item :label="$t('Partners.limit')">
            <el-input-number
              v-model="tempCreditVO.contractCredit"
              no="contractCredit"
              :disabled="true"
              :min="0"
              :precision="0"
              :controls="false"
              style="width:70px;"
            />
            <el-select v-model="tempCreditVO.contractCurrency" no="contractCurrency" style="margin-left:5px;width:88px;" :disabled="true">
              <el-option
                v-for="(item,index) in currencySet"
                :key="index"
                :label="item.code"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('Partners.accountPeriod')">
            <el-input-number
              v-model="tempCreditVO.contractCreditDateLimited"
              no="contractCreditDateLimited"
              :disabled="true"
              :min="0"
              :precision="0"
              :controls="false"
              style="width:74px;"
            />
            <el-select v-model="tempCreditVO.contractTermUnit" no="contractTermUnit" style="margin-left:5px;width:70px;" :disabled="true">
              <el-option :label="$t('Partners.day')" :value="0" />
              <el-option :label="$t('Partners.week')" :value="1" />
              <el-option :label="$t('Partners.month')" :value="2" />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item :label="$t('Partners.settlementType')">
            <el-radio-group v-model="settlementByBill" no="settlementByBill" :disabled="true">
              <el-radio :label="false">{{ $t('Partners.settlementByBill') }}</el-radio>
              <el-radio :label="true">{{ $t('Partners.settlementNotByBill') + '（' + $t('CargoMsg.Cargo_SettlementMethodGreaterThan0') + '）' }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-tabs v-model="activeTabName" type="card" style="width:100%;height: 100%;margin-bottom: 8px">
      <el-tab-pane :lazy="true" :label="$t('CargoMsg.Cargo_TempCredit')" name="otherDocuments" style="width:100%;height: 100%">
        <div class="app-main-inner-row row-grid" style="min-height:300px;">
          <cargo-ag-grid
            :column-defs="tempCreditInfo.columnDefs"
            :grid-options="tempCreditInfo.gridOptions"
            :row-data="tempCreditInfo.rowData"
            :show-side-bar="false"
            style="height:100%;min-height: 220px;"
          />
        </div>
      </el-tab-pane>
    </el-tabs>
    <span>{{ $t('CargoMsg.Cargo_TempCreditNotice') }}</span>
    <template slot="footer" style="height: 65px">
      <approval-comments-and-btns
        :process-info="processInfo"
        :records="records"
        :type="type"
        @close="$emit('close')"
        @closeAndRefresh="$emit('closeAndRefresh')"
      />
    </template>
  </el-dialog>
</template>

<script>

import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import * as ContractConstants from '@/class/cargo/model/parameters/ContractConstants'
import ColumnUtils from '@/utils/ColumnUtils'
import { cache, cacheName } from '@/utils/cacheManager'
import { convertDocument } from '@/api/workflow'
import { TEMP_CREDIT } from '@/class/cargo/model/parameters/WorkflowConstants'
import ApprovalCommentsAndBtns from '@/components/Cargo/Common/Wrokflow/approvalCommentsAndBtns'

export default {
  name: 'TempCreditApplyDialog',
  components: { cargoAdvanceSelect, ApprovalCommentsAndBtns },
  props: {
    visible: { type: Boolean, required: true },
    docId: { type: String, default: () => '' },
    processInfo: { type: Object, default: () => {} }, // 审核流程
    records: { type: Array, default: () => [] }, // 审核记录
    type: { type: String, default: () => '' } // apply-申请，look-查看，approve-审批
  },
  data() {
    return {
      ContractConstants,
      selectTypeNames: TYPE_NAMES,
      innerVisible: false,
      config: {},
      creditUseMultipleCurrency: false,
      dateTypeList: [],
      cbType: '',
      cbTypeList: [],
      tiDateSpecify: '',
      activeTabName: 'otherDocuments',
      tempCreditInfo: {
        columnDefs: [
          {
            headerName: this.$t('CargoMsg.Cargo_EffectiveDate'),
            field: 'effectiveDate',
            colId: 'effectiveDate',
            width: 180,
            minWidth: 180,
            cellRenderer: (params) => {
              return ColumnUtils.dateTimeLabelFunc(params.value)
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_InvalidDate'),
            field: 'expirationDate',
            colId: 'expirationDate',
            width: 180,
            minWidth: 180,
            cellRenderer: (params) => {
              return ColumnUtils.dateTimeLabelFunc(params.value)
            }
          },
          {
            headerName: this.$t('Partners.credit_limit'),
            field: 'credit',
            colId: 'credit',
            width: 80,
            minWidth: 80
          },
          {
            headerName: this.$t('Partners.credit_accountPeriod'),
            field: 'creditDateLimited',
            colId: 'creditDateLimited',
            width: 80,
            minWidth: 80
          }
        ],
        gridOptions: {
          // 单击显示编辑
          singleClickEdit: true,
          onSortChanged: this.rowDataChanged
        },
        rowData: []
      },
      currencySet: new Set(),
      tempCreditVO: {}
    }
  },
  computed: {
    isZh() {
      return this.$store.getters.language === 'zh'
    },
    settlementByBill() { // 结算方式
      return parseInt(this.tempCreditVO.contractCreditDateLimited) > 0 || (this.cbType && this.cbType === 'n')
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      if (newVal) {
        this.init()
      }
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  created() {
    if (this.visible) {
      this.innerVisible = true
      this.init()
    }
  },
  methods: {
    async init() {
      this.tempCreditInfo.rowData = []
      await cache.load(cacheName.CONFIG)
      this.config = cache.config
      this.creditUseMultipleCurrency = Number(this.config.get('creditUseMultipleCurrency')) === 1
      this.dateTypeList = ContractConstants.DATETYPE_TYPE
      this.cbTypeList = [
        { label: this.$t('Partners.monthlySettlement'), value: -1 },
        { label: this.$t('Partners.space3'), value: -2 },
        { label: this.$t('Partners.space4'), value: 'n' },
        { label: this.$t('Partners.space5'), value: -3 },
        { label: this.$t('Partners.dailySettlement'), value: -4 }
      ]

      // 初始化 临时信控 信息
      await convertDocument({ documentConfigId: TEMP_CREDIT.code, docId: this.docId }).then().then(res => {
        this.tempCreditVO = res.data
      })
      if (!this.tempCreditVO) return
      if (this.tempCreditVO.tempCreditChangeVos) {
        this.tempCreditInfo.rowData = this.tempCreditVO.tempCreditChangeVos
      }
      this.fillView()
      this.initCurrencySet()
    },
    fillView() {
      // 结算方式
      if (this.tempCreditVO.contractCreditDateType === -1 || this.tempCreditVO.contractCreditDateType === 0) {
        this.cbType = -1
      } else if (this.tempCreditVO.contractCreditDateType === -2) {
        this.cbType = -2
      } else if (this.tempCreditVO.contractCreditDateType === -3) {
        this.cbType = -3
      } else if (this.tempCreditVO.contractCreditDateType === -4) {
        this.cbType = -4
      } else if (this.tempCreditVO.contractCreditDateType > 0) {
        this.cbType = 'n'
        this.tiDateSpecify = this.tempCreditVO.contractCreditDateType
      }
    },
    initCurrencySet() {
      if (this.creditUseMultipleCurrency) {
        const results = ColumnUtils.getBasicDataCacheList(TYPE_NAMES.basic_data_Currency)
        const priorityCurrencies = results.filter(currency =>
          currency.code === 'RMB' || currency.code === 'USD' || currency.code === 'EUR')
        const otherCurrencies = results.filter(currency =>
          currency.code !== 'RMB' && currency.code !== 'USD' && currency.code !== 'EUR')
        this.currencySet = new Set([...priorityCurrencies, ...otherCurrencies])
      } else {
        this.currencySet = new Set([{ code: 'RMB' }, { code: 'USD' }])
      }
    }
  }
}
</script>
